import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/anniversary-characters-gold.png'


const _withScopeId = n => (_pushScopeId("data-v-302475ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anniversary" }
const _hoisted_2 = { class: "anniversary-title-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "anniversary-title-top-left parallelogram" }, null, -1))
const _hoisted_4 = { class: "anniversary-title-top-desc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "anniversary-title-top-right parallelogram" }, null, -1))
const _hoisted_6 = { class: "anniversary-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "anniversary-title-bottom parallelogram" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "anniversary-characters"
  })
], -1))
const _hoisted_9 = { class: "anniversary-desc" }
const _hoisted_10 = { class: "col-span-1" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "flex mt-2 lg:mt-4" }
const _hoisted_14 = { class: "flex mt-2 lg:mt-4" }
const _hoisted_15 = { class: "col-span-2 lg:pl-12" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "flex mt-2 lg:mt-4" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "flex mt-2 lg:mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('the')), 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('anniversary_collection')), 1),
    _hoisted_7,
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_BalIcon, {
            name: "ci:dot-03-m",
            size: _ctx.upToLargeBreakpoint ? 'xs' : 'xl'
          }, null, 8, ["size"]),
          _createElementVNode("p", {
            innerHTML: 
              _ctx.$t('mint_one_of_3', [
                `<span class='font-bold'>${_ctx.$t('character_nfts')}</span>`,
              ])
            
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_BalIcon, {
            name: "ci:dot-03-m",
            size: _ctx.upToLargeBreakpoint ? 'xs' : 'xl'
          }, null, 8, ["size"]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('3_different_stats_in_game')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_BalIcon, {
            name: "ci:dot-03-m",
            size: _ctx.upToLargeBreakpoint ? 'xs' : 'xl'
          }, null, 8, ["size"]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('random_3333_chance')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_BalIcon, {
            name: "ci:dot-03-m",
            size: _ctx.upToLargeBreakpoint ? 'xs' : 'xl'
          }, null, 8, ["size"]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('receive_exclusive_partner_and_gamefi_airdrops')), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_BalIcon, {
            name: "ci:dot-03-m",
            size: _ctx.upToLargeBreakpoint ? 'xs' : 'xl'
          }, null, 8, ["size"]),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(
                'earn_acs_and_acsi_vault_apy_governance_2.5x_farm_apy_boost_etc'
              )), 1),
            _hoisted_19,
            _createTextVNode(_toDisplayString(_ctx.$t('stacks_with_existing_acs_and_acsi_vault')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_BalIcon, {
            name: "ci:dot-03-m",
            size: _ctx.upToLargeBreakpoint ? 'xs' : 'xl'
          }, null, 8, ["size"]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('higher_rank_NFTs_get_boosted_game_stats_and_many_more')), 1)
        ])
      ])
    ])
  ]))
}